import { LoaderCircle, TriangleAlert } from "lucide-react";

export function Loading({ label = "Cargando información…" }: { label?: string }) {
  return <div className="state"><LoaderCircle className="spin" size={22} /> {label}</div>;
}

export function ErrorNotice({ message }: { message: string }) {
  return <div className="notice error"><TriangleAlert size={18} /> <span>{message}</span></div>;
}

export function Empty({ message = "No se encontraron registros." }: { message?: string }) {
  return <div className="empty">{message}</div>;
}
